import axios from 'axios'
import auth from '@/api/auth/auth'

// Las subidas multipart no pueden usar Api() (fuerza Content-Type:
// application/ld+json), así que se hacen con axios directo y el token
// inyectado a mano — pero eso las deja fuera del interceptor de Api.js que
// refresca el JWT ante un 401. Sin esto, un token caducado en el momento de
// subir un fichero se queda en 401 para siempre, mientras el resto de la
// app (que sí pasa por Api()) se refresca sola. Mismo mecanismo que
// Api.js: un único reintento tras refrescar; si el refresco también falla,
// cierra sesión.
export default async function uploadWithAuth(config) {
  const token = localStorage.getItem('token')
  const requestConfig = {
    ...config,
    headers: { ...config.headers, Authorization: 'Bearer ' + token },
  }

  try {
    return await axios(requestConfig)
  } catch (error) {
    if (error.response?.status !== 401) {
      throw error
    }

    try {
      const newToken = await auth.silentRefresh()
      return await axios({
        ...requestConfig,
        headers: { ...requestConfig.headers, Authorization: 'Bearer ' + newToken },
      })
    } catch (refreshError) {
      await auth.logout()
      throw error
    }
  }
}
